import _ from 'underscore';

export default class ProductEndUses {
  constructor($scope, ProductEndUseService) {
    $scope.product_end_uses = window.product_end_uses;

    $scope.update = function(end_use) {
      end_use.updating = true;
      ProductEndUseService.update(end_use).then(function() {
        end_use.updating = false;
        end_use.edit_mode = false;
        end_use.title = end_use.new_title;
      });
    };

    $scope.delete = function(end_use, hide_confirmation) {
      if (!hide_confirmation && !confirm('Are you sure you want to delete this end use?')) {
        return;
      }

      end_use.deleting = true;
      ProductEndUseService.delete(end_use.id).then(function() {
        $scope.product_end_uses.splice(_.indexOf($scope.product_end_uses, end_use), 1);
        end_use.deleting = false;
      });
    };

    $scope.add = function() {
      ProductEndUseService.add($scope.add_end_uses).then(function(res) {
        $scope.product_end_uses = $scope.product_end_uses.concat(res.data.end_uses);
        $scope.add_end_uses = null;
      });
    };

    $scope.mass_delete = function() {

      var end_uses = _.where($scope.product_end_uses, {
        checked: true
      });
      if (end_uses.length === 0) {
        alert('Please select at least one end use!');
        return false;
      } else {
        if (!confirm('Are you sure you want to delete the selected end uses?')) {
          return;
        }
      }

      _.each(end_uses, function(end_use) {
        $scope.delete(end_use, true);
      });
    };

    $scope.quick_search_end_uses = function() {
      if ($scope.quick_filter) {
        var regex = new RegExp($scope.quick_filter, 'i');
        _.each($scope.product_end_uses, function(end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        $scope.search_filter = {
          visible: true
        };
      } else {
        $scope.search_filter = {};
      }
    };

    $scope.check_end_uses = function() {
      _.each($scope.product_end_uses, function(end_use) {
        end_use.checked = $scope.select_all;
      });
    };
  }
}

ProductEndUses.$inject = ['$scope', 'ProductEndUseService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-end-uses.ctrl.js